import React, { Component } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';

import { showUploadButton } from '../../reducers/history/utils';
import { sendFile } from '../../reducers/history/actions';
import { updateScroll } from '../MessageHistory';
import { visibleActivities } from '../../reducers/history/selectors';
import UploadIcon from '../icons/UploadIcon';

// 10MB file upload limit
const FILE_SIZE_LIMIT = 1024 * 1024 * 10;

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  padding: 0 0 6px 0;
  flex-shrink: 0;
`;

const Lozenge = styled.div`
  padding: 3px 10px;
  margin: 0 5px;
  border-radius: 30px;
  min-width: 30px;

  background: ${props => props.theme.accentColor};
  color: white;
  text-align: center;

  cursor: pointer;

  display: flex;
  align-items: center;
`;

const Label = styled.label`
  display: flex;
  align-items: center;
`;

class UploadButton extends Component {
  constructor(props) {
    super(props);
    this.fileInputRef = React.createRef();
  }

  componentDidUpdate() {
    updateScroll(true);
  }

  onChangeFile = () => {
    const file = this.fileInputRef.current.files[0];

    if (!file) {
      return;
    }

    this.fileInputRef.current.value = null;

    // Limit file size to 10MB
    if (file.size > FILE_SIZE_LIMIT) {
      alert('File too large, please try again');
      return;
    }

    this.props.sendFile(file);
    this.props.inputFieldRef.current.focus();
  };

  render() {
    const { showUploadButton } = this.props;

    if (!showUploadButton) {
      return null;
    }

    return (
      <Wrapper>
        <Lozenge>
          <input
            id="ambit-shell-upload-input"
            type="file"
            style={{ display: 'none' }}
            ref={this.fileInputRef}
            onChange={this.onChangeFile}
          />
          <Label htmlFor="ambit-shell-upload-input" style={{ cursor: 'pointer' }}>
            <UploadIcon />
            <span>Upload File</span>
          </Label>
        </Lozenge>
      </Wrapper>
    );
  }
}

export default connect(
  state => ({
    showUploadButton: showUploadButton(visibleActivities(state)),
    inputFieldRef: state.ui.inputFieldRef
  }),
  { sendFile }
)(UploadButton);



// WEBPACK FOOTER //
// ./src/components/UploadButton/index.js